import { byMethod } from '@oysterjs/core/graphql/actions';
import { merge } from '@oysterjs/core/graphql/loaders';
import type { RouteObject } from 'react-router-dom';
import {
  submitCreateAgencyUser,
  submitCreateAgencyUserForChildAgency,
  submitCreateChildAgency
} from '~/api/data/agencies/mutations';
import { loadChildAgencies } from '~/api/data/agencies/queries';
import { loadAgencyUsers, loadCurrentUser } from '~/api/data/users/queries';
import { Action, Resource } from '~/api/graphql';
import { ProtectedRoute } from '~/components/permissions';
import { CreateAgencyPage } from '~/pages/settings/agencies/create';
import { EditAgencyPage } from '~/pages/settings/agencies/edit';
import { AddUserDialog, SettingsSubscriptionPage } from '~/pages/settings/subscription';

export const subscriptionRoute: RouteObject = {
  path: 'subscription',
  element: (
    <ProtectedRoute
      mode="any"
      permissions={[
        { resource: Resource.Subscription, action: Action.Update },
        { resource: Resource.AgencyUser, action: Action.Create }
      ]}
      redirectTo="/app/settings/integrations"
    >
      <SettingsSubscriptionPage />
    </ProtectedRoute>
  ),
  loader: merge({
    agencyUsers: loadAgencyUsers,
    agencyUser: loadCurrentUser,
    childAgencies: loadChildAgencies
  }),
  children: [
    {
      path: 'users',
      action: byMethod({
        POST: submitCreateAgencyUser
      }),
      element: <AddUserDialog />
    },
    {
      path: 'agencies/create',
      action: byMethod({
        POST: submitCreateChildAgency
      }),
      element: <CreateAgencyPage />
    },
    {
      path: 'agencies/:agencyId',
      loader: merge({
        childAgencies: loadChildAgencies
      }),
      action: byMethod({
        POST: submitCreateAgencyUserForChildAgency
      }),
      element: <EditAgencyPage />
    }
  ]
};
